const isDevelopment = process.env.NODE_ENV === 'development';

/**
 * A simple logger that logs to the console depending on the environment.
 * Errors and warnings are always logged, info logs only in development.
 */
export const log = {
  info: (...args) => {
    isDevelopment && console.log(...args);
  },
  error: (...args) => {
    console.error(...args);
  },
  warn: (...args) => {
    console.warn(...args);
  }
};
